module.exports = __webpack_public_path__ + "img/customer_1_en.03bac537.png";